module.exports = __webpack_public_path__ + "img/achievement_0.c8da526f.png";